import { AfterViewInit, Component, OnInit } from "@angular/core";
import { NgxSmartModalService } from "ngx-smart-modal";
import { CalendarItem } from "../calendar-item";
import { MediaRepository } from "../../../domain/media-repository";
import { MediaInfo, MediaSegment } from "../../../domain/media";
import {
  MediaSegmentsViewModel,
  SegmentViewModel,
} from "../../mediaEditor/media-segments/media-segments.view-model";
import { TenantSettingsRepository } from "../../../domain/tenant-settings-repository";
import { ICommonUtilInterface } from "../../../domain/common/common-util.interface";
import { ShowRepository } from "../../../domain/show-repository";
import { Channel } from "../../../domain/channel";
import { RecordingRepository } from "../../../domain/recording-repository";

@Component({
  selector: "evrideo-choose-segment",
  templateUrl: "./choose-segment.component.html",
  styleUrls: ["./choose-segment.component.scss"],
})
export class ChooseSegmentComponent implements AfterViewInit {
  public mediaId: number;
  public mediaInfo: MediaInfo;
  public channel: Channel;
  public mediaSegmentsViewModel: MediaSegmentsViewModel;
  public onSegmentsSelectedCallback: (segments: MediaSegment[]) => void;

  constructor(
    private _ngxSmartModalService: NgxSmartModalService,
    private _mediaRepository: MediaRepository,
    private _commonUtils: ICommonUtilInterface,
    private _tenantSettingsRepository: TenantSettingsRepository,
    private _showRepository: ShowRepository,
    private _recordingRepository: RecordingRepository,
  ) {}

  public loading = false;
  ngAfterViewInit(): void {
    this.loading = true;
    this.mediaSegmentsViewModel = null;
    this._ngxSmartModalService
      .getModal("chooseSegmentModal")
      .onDataAdded.subscribe(
        (data: {
          mediaId: number;
          onSegmentsSelectedCallback: (segments: MediaSegment[]) => void;
          currentChannel: Channel;
          allowMultiSelect?: boolean;
          onDataBindEnded: () => void;
        }) => {
          this.loading = true;
          this.mediaSegmentsViewModel = null;
          this.onSegmentsSelectedCallback = data.onSegmentsSelectedCallback;
          this.mediaId = null;
          this.mediaInfo = null;
          this.channel = null;
          console.log("ChooseSegmentComponent->ngAfterViewInit", data);
          this.mediaId = data.mediaId;
          this.channel = data.currentChannel;
          // tslint:disable-next-line:radix
          this._mediaRepository
            .getMediaInfo(parseInt(this.mediaId.toString()))
            .then((mediaInfo) => {
              this.mediaInfo = mediaInfo;
              return this._tenantSettingsRepository.getTenantSettings();
            })
            .then(async (tenantSettings) => {
              this.mediaSegmentsViewModel = new MediaSegmentsViewModel(
                this.mediaInfo,
                this._commonUtils,
              );
              this.mediaSegmentsViewModel.timeCodeType = this.channel?.framerate
                ? "FPS"
                : "MS";
              this.mediaSegmentsViewModel.showActionButtons = false;
              this.mediaSegmentsViewModel.fieldsEditable = false;
              this.mediaSegmentsViewModel.rowsMultiselect =
                data.allowMultiSelect ?? false;
              this.mediaSegmentsViewModel.showApplyButton = true;
              this.mediaSegmentsViewModel.showCancelButton = true;

              let entireMediaDurationMs = this.mediaInfo.contentMediaDurationMs;
              if (this.mediaInfo.duringRecording) {
                const searchResults =
                  await this._recordingRepository.getRecordingJobs(
                    null,
                    null,
                    null,
                    this.mediaInfo.id,
                    null,
                    null,
                  );
                const relevantRecordingJob = searchResults[0];
                entireMediaDurationMs = relevantRecordingJob.endTime.diff(
                  relevantRecordingJob.startTime,
                  "milliseconds",
                );
                console.log(
                  "choose-segment->entireMediaDuration=",
                  entireMediaDurationMs,
                  relevantRecordingJob,
                );
              }
              // Add a segment for entire media
              this.mediaSegmentsViewModel.segmentsVM.push(
                new SegmentViewModel(
                  new MediaSegment(
                    this.mediaInfo,
                    null,
                    "",
                    "Entire Media",
                    0,
                    entireMediaDurationMs,
                  ),
                ),
              );
              this.mediaSegmentsViewModel.cancelButtonClicked.subscribe(() => {
                this._ngxSmartModalService
                  .getModal("chooseSegmentModal")
                  .close();
              });
              this.mediaSegmentsViewModel.applyButtonClicked.subscribe(
                async () => {
                  const selectedSegments =
                    this.mediaSegmentsViewModel.segmentsVM.filter(
                      (s) => s.selected,
                    );
                  if (this.onSegmentsSelectedCallback) {
                    this.onSegmentsSelectedCallback(selectedSegments);
                  }
                  this._ngxSmartModalService
                    .getModal("chooseSegmentModal")
                    .close();
                },
              );
              this.loading = false;

              if (data.onDataBindEnded) {
                data.onDataBindEnded();
              }
            });
        },
      );
  }
}
